import { all, put, take } from 'redux-saga/effects';

import { PIPELINE__NOTEBOOK } from 'PipeRouter';
import resetNotebook from './resetNotebook';


function* pipeline() {
  while (true) {
    const { data:{ cmd, data }} = yield take(PIPELINE__NOTEBOOK);

    yield put({ type: cmd, data });
  }
}


export default function* notebook() {
  yield all([
    pipeline(),
    resetNotebook()
  ]);
}
